import { Stack, Typography } from '@mui/material';

import { TestIds } from '@watershed/shared-universal/utils/testUtils';

import { CircularProgressWithTelemetry } from './CircularProgressWithTelemetry';

export default function LoadingPage({
  loadingMessage,
  bg,
}: {
  loadingMessage?: string | null;
  bg?: 'paper' | 'sunken';
}) {
  return (
    <Stack
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      paddingY={6}
      gap={2}
      sx={{
        backgroundColor:
          bg === 'sunken' ? 'grey05' : bg === 'paper' ? 'paper' : undefined,
      }}
      data-testid={TestIds.LoadingPage}
    >
      {/* TODO (DI-12679): All LoadingPages should pass in a unique eventName */}
      <CircularProgressWithTelemetry
        eventName="loadingPage"
        size={32}
        disableShrink
      />
      {loadingMessage && (
        <Typography
          variant="body2"
          sx={{ textWrap: 'balance', maxWidth: '480px', textAlign: 'center' }}
        >
          {loadingMessage}
        </Typography>
      )}
    </Stack>
  );
}
